// Trampos.co typography system
export const fonts = {
  primary: "'Vinila', 'Taviraj', serif",
  secondary: "'Roboto Slab', serif", 
  body: "'Taviraj', serif",
  
  sizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
  },
  
  weights: {
    thin: 100,
    light: 200,
    normal: 400,
    semibold: 600,
    bold: 700,
  }
};